import { call, put, takeLeading } from 'redux-saga/effects'
import getCourse from 'api/courses/Get'
import { onHttpError } from 'helpers/access.helper'
import * as fromActions from '../../actions/courses.action'

async function handleGetCourse(courseId: number) {
  return await getCourse(courseId)
}

function* getCourseEffectSaga(action: any) {
  try {
    const data = yield call(handleGetCourse, action.payload)
    yield put(fromActions.Actions.getCourseSuccess(data))
  } catch (error) {
    onHttpError(error)
    yield put(fromActions.Actions.setCourseLoading(false))
    console.log('error: ', error)
  }
}

export function* getCourseWatcherSaga() {
  yield takeLeading(fromActions.GET_COURSE, getCourseEffectSaga)
}
